import angular from "angular";
import { AdpImportFileExporterModalComponent } from "./adp-import-file-exporter-modal.component";

/**
 * A module related to allowing processors to export an ADP import file.
 */
export const AdpImportFileExporterModule = angular
    .module("apex.mainApp.payroll.processing.adpImportFileExporter", [])
    .component("apexAdpImportFileExporterModal", AdpImportFileExporterModalComponent)
    .name;
